module.exports = __webpack_public_path__ + "static/media/aubergine.73060838.png";